<template>
  <div :class="$style.footer">
    <div :class="$style.inner">
      <div :class="$style.bottom">
        <div class="row">
          <div class="col-sm-6">
            <a
              href="/"
              class="mr-4"
            >
              {{ $t('footer.home') }}
            </a>
            <a
              :href="config.runURL"
              target="_blank"
              class="mr-4"
            >
              {{ $t('footer.join') }}
            </a>
            <a
              href="https://www.facebook.com/gogame.run"
              target="_blank"
              class="mr-4"
            >
              {{ $t('footer.support') }}
            </a>
          </div>
          <div class="col-sm-6">
            <div :class="$style.copyright">
              <img
                src="resources/images/logo-color.png"
                rel="noopener noreferrer"
                alt="Mediatec Software"
              />
              <span>
                © 2019
                <a
                  href="http://mediatec.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >GoStream Jsc</a>
                <br />All rights reserved
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  data() {
    return {
      config
    }
  }
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
